export default __webpack_public_path__ + "static/media/INEX.67349088.svg";